import { jsx as _jsx } from "react/jsx-runtime";
// import { newTreatmentRequestDisabledReason } from "./menu_model_contants";
import org_model from "models/org_model";
import user_model from "models/user_model";
import { CartCount } from "./components/CartCount";
import { canCaptureComplication } from "../complications/helpers";
export const getMenuItems = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    // Wait for site_status to be ready
    if (!app.site_status) {
        return [];
    }
    const isPrescriberRole = (app.acl.is_nurse || app.acl.is_doc_presc) && !app.acl.is_admin;
    // const isCosmDevice = org_model.org_conf_itm(app.user.org, "meds") &&
    //     org_model.org_conf_itm(app.user.org, "meds") != "pharm" &&
    //     user_model.check_access("pg_med", org_model.org_conf_itm(app.user.org, "meds"));
    const canPrescribe = isPrescriberRole; //&& isCosmDevice;
    const isLegOper = app.acl.is_leg_oper;
    const isCosmDoc = app.acl.is_cosm_doc;
    const canViewScripts = (app.acl.is_admin ||
        app.acl.is_supp ||
        app.acl.is_doc_gp ||
        app.acl.is_nurse ||
        app.acl.is_NP ||
        (app.acl.is_mang && !["maas", "spon", "patho_partner"].includes((_a = app.user.org) === null || _a === void 0 ? void 0 : _a.type))) &&
        !app.settings.ileg;
    const isNurseAndHigher = app.acl.is_admin || app.acl.is_doc_gp || app.acl.is_mang || app.acl.is_nurse || app.acl.is_NP;
    const canAccessInventory = user_model.check_access("inventory:view");
    const canAccessDrugBook = user_model.check_access("drug-book:view");
    const canAddStock = user_model.check_access("inventory:add");
    const canShop = (app.acl.is_admin ||
        ((_d = (_c = (_b = app.user.org) === null || _b === void 0 ? void 0 : _b.conf) === null || _c === void 0 ? void 0 : _c.prods_sale) === null || _d === void 0 ? void 0 : _d.includes("med_cosm")) ||
        ((_h = (_g = (_f = (_e = app.user) === null || _e === void 0 ? void 0 : _e.prof) === null || _f === void 0 ? void 0 : _f.xtra) === null || _g === void 0 ? void 0 : _g.prods_sale) === null || _h === void 0 ? void 0 : _h.includes("med_cosm"))) &&
        user_model.check_access("buy_prods");
    const canUserAdmin = user_model.check_access("user_admin");
    const canTestVid = app.acl.is_admin || app.acl.is_nurse || app.acl.is_doc;
    const canBook = ((_k = (_j = app === null || app === void 0 ? void 0 : app.site_status) === null || _j === void 0 ? void 0 : _j.booking) === null || _k === void 0 ? void 0 : _k.show_org_booking_menu) &&
        ((_m = (_l = app === null || app === void 0 ? void 0 : app.user) === null || _l === void 0 ? void 0 : _l.org) === null || _m === void 0 ? void 0 : _m.type) === "cosm" &&
        (app.acl.is_mang || app.acl.is_nurse);
    const canCompleteAudits = app.acl.is_nurse || app.acl.is_mang;
    const canMakePayment = !app.acl.is_usr && !isCosmDoc;
    const canViewTransactions = app.user.claims &&
        ((((_o = app.user.org) === null || _o === void 0 ? void 0 : _o.type) == "cosm" && ((_r = (_q = (_p = app.user.org) === null || _p === void 0 ? void 0 : _p.conf) === null || _q === void 0 ? void 0 : _q.prods_sale) === null || _r === void 0 ? void 0 : _r.includes("med_cosm"))) ||
            ((_v = (_u = (_t = (_s = app.user) === null || _s === void 0 ? void 0 : _s.prof) === null || _t === void 0 ? void 0 : _t.xtra) === null || _u === void 0 ? void 0 : _u.prods_sale) === null || _v === void 0 ? void 0 : _v.includes("med_cosm")) ||
            app.acl.is_admin);
    return [
        ...(canShop && app.settings.is_mob_sz
            ? [{ name: _jsx(CartCount, {}), link: "/products/shop/cart" }]
            : []),
        {
            name: isCosmDoc ? "Scripting" : "Treatment Plans",
            link: canPrescribe && !isLegOper && org_model.new_script_route(),
            sublinks: [
                ...(isPrescriberRole
                    ? [
                        {
                            name: "Create New Treatment Plan",
                            link: org_model.new_script_route(),
                            // disabled: !isCosmDevice ? { content: newTreatmentRequestDisabledReason } : false,
                        },
                    ]
                    : []),
                ...(canViewScripts && !isCosmDoc
                    ? [
                        {
                            name: "View Treatment Plans",
                            link: "/treatments",
                        },
                    ]
                    : []),
                ...(isNurseAndHigher && !isCosmDoc
                    ? [
                        {
                            name: "Manage Patients",
                            link: "/patients",
                        },
                    ]
                    : []),
                ...(isCosmDoc
                    ? [
                        {
                            name: "Waiting Room",
                            link: "/instcons_wr/cosm",
                        },
                        {
                            name: "All Scripts",
                            link: "/scripts/list",
                        },
                        {
                            name: "Patient search",
                            link: "/patients",
                        },
                    ]
                    : []),
            ],
        },
        canBook && {
            name: "Bookings",
            sublinks: [
                ...(app.acl.is_nurse || app.acl.is_mang
                    ? [
                        {
                            name: "Book Patient",
                            link: `/admin/org-booking/new/${(_w = app.user.org) === null || _w === void 0 ? void 0 : _w.oid}`,
                        },
                    ]
                    : []),
                ...(app.acl.is_nurse || app.acl.is_mang
                    ? [
                        {
                            name: "Manage Rosters",
                            link: app.acl.is_mang ? "/admin/org-booking/users" : "/org-booking/roster",
                            sublinks: [],
                        },
                    ]
                    : []),
                ...(app.acl.is_nurse || app.acl.is_mang ? [
                    {
                        name: "View Appointments",
                        link: app.acl.is_mang
                            ? "/admin/org-booking/appointments"
                            : "/org-booking/appointments",
                    },
                ] : []),
                ...(app.acl.is_mang
                    ? [
                        {
                            name: "Manage Bookings",
                            link: "/admin/org-booking/appointments",
                        },
                    ]
                    : []),
            ],
        },
        {
            name: "Stock",
            sublinks: [
                ...(canAccessInventory
                    ? [
                        {
                            name: "View Stock on Hand",
                            link: "/inventory",
                        },
                    ]
                    : []),
                ...(canAccessDrugBook
                    ? [
                        {
                            name: "View Drug Book",
                            link: "/drugbook",
                        },
                    ]
                    : []),
                ...(canShop
                    ? [
                        {
                            name: "Buy Stock",
                            link: "/products/shop",
                        },
                    ]
                    : []),
                ...(canAddStock
                    ? [
                        {
                            name: "Add Stock",
                            link: "/inventory",
                        },
                    ]
                    : []),
                ...(canViewTransactions
                    ? [
                        {
                            name: "View Transactions",
                            link: "/trans/list",
                        },
                    ]
                    : [])
            ],
        },
        !isCosmDoc && {
            name: "Training",
            link: "https://dermamedical.net.au/cosmetic-training-courses-australia/",
        },
        {
            name: "Admin",
            sublinks: [
                ...(isNurseAndHigher
                    ? [
                        {
                            name: "View Script Statistics",
                            link: "/scripts/stats",
                        },
                        // { This is in the requirements but tier status just leads to profile
                        //     name: "View Tier Status",
                        //     disabled: { content: "Tier status is coming soon" },
                        // },
                    ]
                    : []),
                {
                    name: "Manage Profile",
                    link: "/profile",
                },
                ...(app.acl.is_mang
                    ? [
                        {
                            name: "Manage Clinic",
                            link: "/org/my-clinic-profile",
                        },
                    ]
                    : []),
                ...(canUserAdmin
                    ? [
                        {
                            name: "Manage Users",
                            link: "/admin/users",
                        },
                    ]
                    : []),
                ...(canCompleteAudits
                    ?
                        [{
                                name: "View Audits",
                                sublinks: [
                                    ...(app.acl.is_mang
                                        ? [
                                            {
                                                name: "View Clinic Audits",
                                                link: "/cosm/audit/list/clinic",
                                            },
                                        ]
                                        : []),
                                    ...(app.acl.is_nurse
                                        ? [
                                            {
                                                name: "View Practitioner Audits",
                                                link: "/cosm/audit/list/practitioner",
                                            },
                                        ]
                                        : []),
                                ],
                            }]
                    : []),
                ...(canMakePayment
                    ? [
                        {
                            name: "Make Payment",
                            link: "/payment",
                        },
                    ]
                    : []),
            ],
        },
        {
            name: "Help",
            sublinks: [
                ...(canCaptureComplication()
                    ? [
                        {
                            name: "Capture Complication",
                            link: `/capture-complication`,
                        },
                    ]
                    : []),
                {
                    name: "View FAQs",
                    link: "/instantcosmetics-faqs",
                },
                {
                    name: "Contact Support",
                    act: () => app.trigger(app.events.SHOW_POPUP, {
                        tp: "pu",
                        pt: "contact",
                        txt: "Contact Us",
                        u: "contact-us",
                    }),
                },
                ...(app.acl.is_nurse || app.acl.is_mang
                    ? [
                        {
                            name: "View Documents",
                            link: "/documents/cosm_pp",
                        },
                    ]
                    : []),
                ...(canTestVid
                    ? [
                        {
                            name: "Test Video Call",
                            link: "/vidcall-troubleshooting",
                        },
                    ]
                    : []),
            ],
        },
    ].filter(item => { var _a; return (item === null || item === void 0 ? void 0 : item.link) || ((_a = item === null || item === void 0 ? void 0 : item.sublinks) === null || _a === void 0 ? void 0 : _a.length); });
};
